// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-default[disabled]:hover {
  background-color: #f4f4f4;
  border-color: #ddd;
}

.btn-primary[disabled]:hover {
  background-color: #3c8dbc;
  border-color: #367fa9;
}

.btn-success[disabled]:hover {
  background-color: #00a65a;
  border-color: #008d4c;
}

.btn-info[disabled]:hover {
  background-color: #00c0ef;
  border-color: #00acd6;
}

.btn-danger[disabled]:hover {
  background-color: #dd4b39;
  border-color: #d73925;
}

.btn-warning[disabled]:hover {
  background-color: #f39c12;
  border-color: #e08e0b;
}

.btn-outline[disabled]:hover {
  color: #fff;
  border: 1px solid #fff;
}

.btn[disabled][class*="bg-"]:hover {
  box-shadow: inset 0 0 100px #0003;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/containers/App/styles/adminlte-buttons-fix.css","webpack://./services/frontend/app/containers/App/styles/adminlte-buttons-fix.css"],"names":[],"mappings":"AAMA;ECLE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["/*\n   AdminLTE customizes Bootstrap button colors in a wrong way, so disabled buttons\n   still have hover state when `pointer-events: none` is not specified (which is\n   sometimes not wanted). This resets hover styles of disabled buttons to match\n   non-hover state in AdminLITE similarly how Bootstrap does that itself.\n */\n\n.btn-default[disabled]:hover {\n  background-color: #f4f4f4;\n  border-color: #ddd;\n}\n\n.btn-primary[disabled]:hover {\n  background-color: #3c8dbc;\n  border-color: #367fa9;\n}\n\n.btn-success[disabled]:hover {\n  background-color: #00a65a;\n  border-color: #008d4c;\n}\n\n.btn-info[disabled]:hover {\n  background-color: #00c0ef;\n  border-color: #00acd6;\n}\n\n.btn-danger[disabled]:hover {\n  background-color: #dd4b39;\n  border-color: #d73925;\n}\n\n.btn-warning[disabled]:hover {\n  background-color: #f39c12;\n  border-color: #e08e0b;\n}\n\n.btn-outline[disabled]:hover {\n  border: 1px solid #fff;\n  color: #fff;\n}\n\n.btn[disabled][class*='bg-']:hover {\n  box-shadow: inset 0 0 100px rgba(0, 0, 0, 0.2);\n}\n",".btn-default[disabled]:hover {\n  background-color: #f4f4f4;\n  border-color: #ddd;\n}\n\n.btn-primary[disabled]:hover {\n  background-color: #3c8dbc;\n  border-color: #367fa9;\n}\n\n.btn-success[disabled]:hover {\n  background-color: #00a65a;\n  border-color: #008d4c;\n}\n\n.btn-info[disabled]:hover {\n  background-color: #00c0ef;\n  border-color: #00acd6;\n}\n\n.btn-danger[disabled]:hover {\n  background-color: #dd4b39;\n  border-color: #d73925;\n}\n\n.btn-warning[disabled]:hover {\n  background-color: #f39c12;\n  border-color: #e08e0b;\n}\n\n.btn-outline[disabled]:hover {\n  color: #fff;\n  border: 1px solid #fff;\n}\n\n.btn[disabled][class*=\"bg-\"]:hover {\n  box-shadow: inset 0 0 100px #0003;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
